
import { createContext } from "react";

const FilterContext = createContext(true);
export default FilterContext;

